var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "brands_selection_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "title" } },
        [
          _c("div", [_vm._v("品牌严选标题")]),
          _c("el-input", {
            attrs: { placeholder: "输入0-4个字的名称", clearable: "" },
            model: {
              value: _vm.value.config.title,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "title", $$v)
              },
              expression: "value.config.title",
            },
          }),
        ],
        1
      ),
      _c("el-form-item", { attrs: { prop: "imageurl" } }, [
        _c("div", [_vm._v("品牌背景图")]),
        _c("div", { staticClass: "upload" }, [
          _c(
            "div",
            { staticClass: "upload-item-wrap" },
            [
              _c("upload-file", {
                ref: "uploadBanner",
                attrs: {
                  "link-url": _vm.linkUrl,
                  tempurl: _vm.value.config.imageurl,
                  uploadInfo: _vm.uploadInfo,
                },
                on: { emitUploadFile: _vm.emitUploadFile },
              }),
              _c(
                "div",
                { staticClass: "btns" },
                [
                  _c("el-button", { on: { click: _vm.onUpload } }, [
                    _vm._v(" 上传图片 "),
                  ]),
                  _vm.pictureList.length > 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.selectPicture },
                        },
                        [_vm._v(" 选择图片 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 建议尺寸为690*180，支持JPG、PNG等格式，大小不超过2M "),
          ]),
        ]),
      ]),
      _c(
        "el-form-item",
        { attrs: { prop: "text_color" } },
        [
          _c("div", [
            _vm._v(" 品牌文字颜色 "),
            _c("span", { staticClass: "tips" }, [
              _vm._v("（包括：标题名称、品牌文字和“>”图标的颜色）"),
            ]),
          ]),
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.text_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "text_color", $$v)
              },
              expression: "value.config.text_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "addFormItem", attrs: { prop: "brand_show_type" } },
        [
          _c("div", { staticClass: "title" }, [_vm._v("首页品牌显示模式")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.brand_show_type,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "brand_show_type", $$v)
                },
                expression: "value.config.brand_show_type",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v("封面品牌显示完后按品牌顺序自动填充"),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v("仅显示封面品牌"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "category_id" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("点击更多时跳转的菜单")]),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { filterable: "", placeholder: "选择蛋糕类型的菜单" },
              on: { change: _vm.changeCategory },
              model: {
                value: _vm.value.config.category_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "category_id", $$v)
                },
                expression: "value.config.category_id",
              },
            },
            _vm._l(_vm.menuListFilter, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: {
                  label: item.show_name,
                  value: item.id,
                  disabled: item.disabled,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("el-form-item", { staticClass: "brandName" }, [
        _c("div", { staticClass: "label" }, [_vm._v("设置组件封面展示品牌")]),
        _c("div", { staticClass: "tips" }, [
          _vm._v("已添加的封面品牌拖动可排序，点击右上方按钮删除"),
        ]),
        _c(
          "div",
          { staticClass: "add-box" },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "value-key": "id",
                  placeholder: "搜索或选择品牌",
                  clearable: "",
                  filterable: "",
                  disabled: !_vm.value.config.category_id,
                },
                model: {
                  value: _vm.bidObj,
                  callback: function ($$v) {
                    _vm.bidObj = $$v
                  },
                  expression: "bidObj",
                },
              },
              _vm._l(_vm.list, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: {
                    label: item.brand_name,
                    value: item,
                    disabled: _vm.value.config.bids.includes(item.id),
                  },
                })
              }),
              1
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.addBrand } },
              [_vm._v("添加到封面")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-form-item",
        { staticClass: "brandList", attrs: { prop: "brandList" } },
        [
          _c(
            "draggable",
            {
              attrs: { animation: "500", "force-fallback": true },
              model: {
                value: _vm.value.config.brandList,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "brandList", $$v)
                },
                expression: "value.config.brandList",
              },
            },
            _vm._l(_vm.value.config.brandList, function (item, index) {
              return _c("div", { key: item.id, staticClass: "brand" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(" " + _vm._s(item.brand_name) + " "),
                ]),
                _c("i", {
                  staticClass: "el-icon el-icon-close",
                  on: {
                    click: function ($event) {
                      return _vm.deleteBrand(index)
                    },
                  },
                }),
              ])
            }),
            0
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "margin_top", attrs: { prop: "margin_top" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "z_index", attrs: { prop: "z_index" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }